import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

import { ApiAiClient } from "api-ai-javascript/es6/ApiAiClient";

import { BehaviorSubject } from "rxjs/BehaviorSubject";

// Message class for displaying messages in the component
export class Message {
  constructor(
    public content: string,
    public sentBy: string,
    public payloadMessages?: PayloadMessage[]
  ) {}
}
export class PayloadMessage {
  constructor(public payloadTitle: string, public payloadValue: string) {}
}

@Injectable()
export class ChatService {
  readonly token = "5b2fe3b89c304388b3699a069006ba50";
  readonly client = new ApiAiClient({ accessToken: this.token });

  conversation = new BehaviorSubject<Message[]>([]);

  payloadConversation = new BehaviorSubject<PayloadMessage[]>([]);
  constructor() {}

  // Sends and receives messages via DialogFlow
  converse(msg: string) {
    const userMessage = new Message(msg, "user");
    this.update(userMessage);

    this.client.textRequest(msg).then((res) => {
      const messages = res.result.fulfillment.messages;

      messages.forEach((message) => {
        if (message.replies) {
          const botPayload = new Message("Alege o varianta:", "user", []);
          message.replies.forEach((att) => {
            const buttPayload = new PayloadMessage(att, att);
            botPayload.payloadMessages.push(buttPayload);
          });
          this.update(botPayload);
        }
        if (!(message.lang === "en")) {
          if (message.type === 0) {
            const payloadMess = message.speech;
            // tslint:disable-next-line: max-line-length
            const botPayload = new Message(payloadMess, "bot");
            this.update(botPayload);
          }
        } else {
          if (message.platform === "skype") {
            if (message.type === 4) {
              if (message.payload.type === "reset") {
                // tslint:disable-next-line: max-line-length
                const botPayload = new Message("reset", "bot");
                this.update(botPayload);
              }

              if (message.payload.skype.attachments) {
                message.payload.skype.attachments.forEach((att) => {
                  const mess = att.content.text;
                  const payloadButtons = att.content.buttons;
                  const botPayload = new Message(mess, "user", []);
                  payloadButtons.forEach((butt) => {
                    const buttTitle = butt.title;
                    const buttValue = butt.value;
                    const buttPayload = new PayloadMessage(
                      buttTitle,
                      buttValue
                    );
                    botPayload.payloadMessages.push(buttPayload);
                  });

                  this.update(botPayload);
                });
              }
            } else if (message.type === 0) {
              const payloadMess = message.speech;
              // tslint:disable-next-line: max-line-length
              const botPayload = new Message(payloadMess, "bot");
              this.update(botPayload);
            }
          }
        }
      });
    });
    return 0;
  }
  // Adds message to source
  update(msg: Message) {
    this.conversation.next([msg]);
  }
}
